var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status != 3)?_c('div',{staticClass:"option_box_div"},[_c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":function($event){return _vm.endButton()}}},[_vm._v(_vm._s(_vm.status == 1 ? "开始活动" : _vm.status == 2 ? "结束此环节" : ""))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }